module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/Player-f74ac00adf5df45c659473ae0648897b.svg";